import ParticipantRecords from './ParticipantRecords'

export default ParticipantRecords
